module.exports = __webpack_public_path__ + "static/media/raposa2.011eaea5.png";